module.exports = __webpack_public_path__ + "covidPPPtable/img/theM.27241498.jpg";